<template>
  <div class="c-poster-viewer">
    <v-img
      :src="src"
      contain
    />
  </div>
</template>

<script>
export default {
  name: 'PosterViewer',

  components: {},

  props: {
    content: {
      type: Object,
      required: true
    },

    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    },

    params: {
      type: Object,
      required: false,
      default: () => {}
    }
  },

  data: function () {
    return {
      src: this.content.contentURL
    }
  }
}
</script>

<style lang="css" scoped>
.c-poster-viewer {
  width: 100%;
  height: auto;
}
</style>
